export default "__VITE_ASSET__DeCKRdT0__"